const messages = {
  title: "Moj osebni izvještaj računa",
  desc: "Tu lahko vidite vaš osebni izvještaj Bridgestone Plus računa z vašimi zasluženimi in uporabljenimi bonus točkami. Prosimo upoštevajte, da lahko traja do 6 tednov, da se točke zaračunajo za vaša naročila pnevmatik, odvisno od vira.",
  score: "Stanje točk",
  regularPoints: "Redne točke",
  boosterPoints: "Bonus točke",
  date: "Datum",
  supplySourceReason: "Vir/Razlog za nakup",
  article: "Artikel",
  brand: "Blagovna znamka",
  product: "Izdelek",
  type: "Tip",
  inch: "Palec",
  season: "Sezona",
  amount: "Količina",
  standardPoints: "Točke",
  boosterProduct: "Bonus izdelek",
  boosterSeason: "Bonus sezona",
  otherActions: "Druge akcije ali razlogi",
  totalPoints: "Skupaj točk",
  income: "Prihodek",
  spending: "Odhodki",
  lastMonth: "Zaključno stanje",
  loadMore: "Naloži še 20 transakcij",
  typeFilter: "Filtriraj po viru",
  dateFilter: "Filtriraj po obdobju",
  customer_number: "Številka stranke",
  currentPoints: "Trenutne točke",
  calculationDate: "Datum izračuna",
  positivePoints: "Pozitivne točke",
  negativePoints: "Že porabljeno",
  tyresAmount: "Število pnevmatik na leto",
  pointsTotal: "Skupaj točk",
  currentPointState: "Trenutno stanje točk",
  currentKickbackState: "Trenutni kešbek",
  pointsFromCurrentYear: "Dodatek: točke iz tekočega leta ({year})",
  pointsAtRiskOfExpiry: "Točke za porabo do 31.03.{year}",
  points: "Točke",
  noDataFound: "Podatki niso bili najdeni",
  seasons: {
    summer: "Poletje",
    winter: "Zima",
    all: "Vse sezone",
  },
};
export default {
  messages,
};
